
import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import "react-tabs/style/react-tabs.css";
import Close_black from "../../../assets/close_black.svg";
import CalenderMark from "../../../assets/images/calender-mark.svg";
import formBg from "../../../assets/images/creator-left-bg.svg";
import scaleMark from "../../../assets/images/scale-mark.png";
import formIcon1 from "../../../assets/images/form-icon-1.svg";
import formIcon2 from "../../../assets/images/form-icon-2.svg";
import formIcon3 from "../../../assets/images/form-icon-3.svg";
import formIcon4 from "../../../assets/images/form-icon-4.svg";
import formIcon5 from "../../../assets/images/form-icon-5.svg";
import formIcon6 from "../../../assets/images/form-icon-6.svg";
import formIcon7 from "../../../assets/images/form-icon-7.svg";
import formIcon8 from "../../../assets/images/form-icon-8.svg";
import formIcon9 from "../../../assets/images/form-icon-9.svg";
import formIcon10 from "../../../assets/images/form-icon-10.svg";
import formIcon11 from "../../../assets/images/form-icon-11.svg";
import formIcon12 from "../../../assets/images/form-icon-12.svg";
import formIcon13 from "../../../assets/images/form-icon-13.svg";
import formIcon14 from "../../../assets/images/form-icon-14.svg";
import formIcon15 from "../../../assets/images/form-icon-15.svg";
import formIcon16 from "../../../assets/images/form-icon-16.svg";
import formIcon17 from "../../../assets/images/form-icon-17.svg";
import socialIcon1 from "../../../assets/insta-icon.svg";
import socialIcon2 from "../../../assets/facebook-icon.svg";
import socialIcon3 from "../../../assets/youtube-icon.svg";
import socialIcon4 from "../../../assets/twitter-icon.svg";
import { MuiChipsInput } from 'mui-chips-input'
import CloseIcon from '@mui/icons-material/Close';
import formIcon18 from "../../../assets/images/form-icon-18.svg";
import formIcon19 from "../../../assets/images/form-icon-19.svg";
import formIcon20 from "../../../assets/images/form-icon-20.svg";
import formIcon21 from "../../../assets/images/form-icon-21.svg";
import formIcon22 from "../../../assets/images/form-icon-22.svg";
import formIcon23 from "../../../assets/images/form-icon-23.svg";
import formIcon24 from "../../../assets/images/form-icon-24.svg";
import formIcon25 from "../../../assets/images/form-icon-25.svg";
import TooltipIcon from "../../../assets/images/tool-tip-icon.svg";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Calendar } from "react-multi-date-picker";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import {
    addCreatorDetail,
    getAdjectives,
    getAwards,
    getBodyParts,
    getBodyTypes,
    getBrand,
    getClothingStyles,
    getEyeColors,
    getFoodPreferences,
    getHairColors,
    getHairLength,
    getHairType,
    getLanguage,
    getOtherSkills,
    getPersonalDetail,
    getPhoneBrands,
    getSkinColors,
    getStrengths,
    getVideoShootingTypes,
    getVoiceTypes,
    getTattoosBodyParts,
    getPiercingBodyParts,
    getBirthmarkBodyParts,
    onCheckValidateAccount,
    getProfileDetails,
    updatePersonalData,
    checkCookies,
    logOutPublicCreatot,
    logOutPublicCreator,
} from "../../../services";
import {
    GET_PERSONAL_DETAIL,
    REGISTER_DETAILS,
} from "../../../redux/action_type";
import { Controller, useForm } from "react-hook-form";
import $ from "jquery";
import moment from "moment";
import { countJSON, feetJSON, inchesJSON } from "../../../constants";
import { useToast } from "../../../toast";
import { useDispatch, useSelector } from "react-redux";
import { onJustReducerUpdate } from "../../../redux/action";
import * as yup from "yup";
import { FaInfoCircle } from "react-icons/fa"
import { yupResolver } from "@hookform/resolvers/yup";
import { isValidUrl } from "../../../utils/common";
import _ from 'lodash';
import IsLoadingHOC from "../../HOC/loader/IsLoadingHOC";
import { addPersonalDetail } from "../../../services";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const PublicCreatorForm = (props) => {
    const { setLoading } = props;
    const history = useHistory();
    const [dropDownValues, setDropDownValues] = useState({});
    const [selectedTabs, setSelectedTabs] = useState(0);
    const [agePicker, setAgePicker] = useState("");
    const [LinkSubmit, setLinkSubmit] = useState({});
    const [basicSubmit, setBasicSubmit] = useState({});
    const [physicalSubmit, setPhysicalSubmit] = useState({});
    const [personalitySubmit, setPersonalitySubmit] = useState({});
    const [submitValueOne, setSubmitValueOne] = useState(false);
    const [submitValueTwo, setSubmitValueTwo] = useState(false);
    const [submitValueThree, setSubmitValueThree] = useState(false);
    const [submitValueFour, setSubmitValueFour] = useState(false);
    const [validateDetail, setValidateDetail] = useState({})
    const dispatch = useDispatch();
    const toast = useToast();
    const [platformData, setPlatform] = useState({})
    const [channelName, setChannelName] = useState("");
    const [personalData, setPersonalData] = useState({})
    const [isFormUpdate, setIsFormUpdate] = useState(false);
    const [tabTwoDataRestrict, setTabTwoDataRestrict] = useState(false)
    const [tabThreeDataRestrict, setTabThreeDataRestrict] = useState(false)
    const [tabFourDataRestrict, setTabFourDataRestrict] = useState(false)
    const isPathName = window.location.pathname

    // const personalData = useSelector((state)=> state.personalDetail)
    const prefix = "@";
    const socialMediaOptions = [
        { value: "instagram", label: "Instagram", icon: socialIcon1 },
        { value: "facebook", label: "Facebook", icon: socialIcon2 },
        { value: "youtube", label: "Youtube", icon: socialIcon3 },
    ];
    const onValueChange = (value) => {
        setChannelName(value);
    };
    const formatOptionLabel = ({ label, icon }) => (
        <div className="icon-label-select-option">
            <img
                className="drop-down-img"
                src={icon}
                style={{ width: 20 }}
                alt={label}
            />
            <div className="drop-down-option">{label}</div>
        </div>
    );

    useEffect(() => {
        setSelectedTabs(0);
        cookiesVerify()
    }, []);

    const cookiesVerify = async () => {
        try {
            setLoading(true);
            let response = await checkCookies();
            if (response.status) {
                history.push('/creator-form');
            } else {
                history.push('/creator-landing');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }
    const customStyles = {
        menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
    };

    const weekDays = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];

    const onDatePick = () => {
        $("#open-date-picker").modal("hide");
    };

    useEffect(() => {
        if (agePicker) {
            const dob = moment(agePicker).format("DD/MM/YYYY");
            setValueTwo("dob", dob);
        }
    }, [agePicker]);

    const schema = yup.object().shape({
        social_platform: yup.object().required("*Required"),
        account_handle: yup.string().required("*Required"),
    });

    const {
        register: register,
        handleSubmit,
        control: control,
        reset,
        setValue,
        getValues,
        watch,
        formState: { errors, isDirty },
    } = useForm({ resolver: yupResolver(schema) });
    const accountFormData = getValues()
    const accountWatch = watch()
    const {
        register: registerTwo,
        handleSubmit: handleSubmitTwo,
        control: controlTwo,
        getValues: getValuesTwo,
        setValue: setValueTwo,
        watch: watchTwo,
        reset: resetTwo,
        formState: { errors: errorsTwo, isDirty: isDirtyTwo },
    } = useForm();
    const basicDataFormData = getValuesTwo()
    const basicDataWatch = watchTwo()
    watchTwo("other_languages", false);
    const {
        register: registerThree,
        handleSubmit: handleSubmitThree,
        control: controlThree,
        getValues: getValuesThree,
        setValue: setValueThree,
        watch: watchThree,
        reset: resetThree,
        formState: { errors: errorsThree, isDirty: isDirtyThree },
    } = useForm();
    const physicalFormData = getValuesThree()
    const physicalWatch = watchThree()
    watchThree("other_hair_color", false);
    watchThree("other_hair_length", false);
    watchThree("other_tattoos", false);
    watchThree("other_piercing", false);
    watchThree("other_birthmark_moles", false);

    const {
        register: registerFour,
        handleSubmit: handleSubmitFour,
        control: controlFour,
        getValues: getValuesFour,
        setValue: setValueFour,
        watch: watchFour,
        reset: resetFour,
        formState: { errors: errorsFour, isDirty: isDirtyFour },
    } = useForm();
    const personalFormData = getValuesFour()
    const personalWatch = watchFour()
    watchFour("other_adjectives", false);
    watchFour("other_phone_brand", false);

    useEffect(() => {
        if (parseInt(getValuesThree("count_tattoo")?.value) < (physicalFormData?.tattoos?.some(a => a.value === "other") ? physicalFormData?.tattoos?.length - 1 : physicalFormData?.tattoos?.length) + physicalFormData?.other_tattoos?.length) {
            setValueThree("tattoos", [])
            setValueThree("other_tattoos", [])
        }
        if (parseInt(getValuesThree("count_piercing")?.value) < (physicalFormData?.piercing?.some(a => a.value === "other") ? physicalFormData?.piercing?.length - 1 : physicalFormData?.piercing?.length) + physicalFormData?.other_piercing?.length) {
            setValueThree("piercing", [])
            setValueThree("other_piercing", [])
        }
        if (parseInt(getValuesThree("count_mole")?.value) < (physicalFormData?.birthmark_moles?.some(a => a.value === "other") ? physicalFormData?.birthmark_moles?.length - 1 : physicalFormData?.birthmark_moles?.length) + physicalFormData?.other_birthmark_moles?.length) {
            setValueThree("birthmark_moles", [])
            setValueThree("other_birthmark_moles", [])
        }
        if (!basicDataFormData?.languages?.some(a => a.value === "other")) {
            setValueTwo("other_languages", [])
        }
        if (physicalFormData?.hair_color?.text === "Other" === false) {
            setValueThree("other_hair_color", [])
        }
        if (physicalFormData?.hair_length?.text === "Other" === false) {
            setValueThree("other_hair_length", [])
        }
        if (!physicalFormData?.tattoos?.some(a => a.value === "other")) {
            setValueThree("other_tattoos", [])
        }
        if (!physicalFormData?.piercing?.some(a => a.value === "other")) {
            setValueThree("other_piercing", [])
        }
        if (!physicalFormData?.birthmark_moles?.some(a => a.value === "other")) {
            setValueThree("other_birthmark_moles", [])
        }
        if (!personalFormData?.adjectives?.some(a => a.value === "other")) {
            setValueFour("other_adjectives", [])
        }
        if (!personalFormData?.phone_brand?.some(a => a.value === "other")) {
            setValueFour("other_phone_brand", [])
        }
    }, [getValuesThree("count_tattoo"), getValuesThree("count_mole"), getValuesThree("count_piercing"), getValuesTwo("languages"), getValuesThree("hair_color"), getValuesThree("hair_length"), getValuesThree("tattoos"), getValuesThree("piercing"), getValuesThree("birthmark_moles"), getValuesFour("adjectives"), getValuesFour("phone_brand")])


    useEffect(() => {
        if (isPathName === "/creator-form") {
        function confirmNavigation(event) {
            event.preventDefault();
            if (isDirty || isDirtyTwo || isDirtyThree || isDirtyFour) {
                event.returnValue = "";
            } else {
                return null
            }
        }
        window.addEventListener("beforeunload", confirmNavigation);

        return () => window.removeEventListener("beforeunload", confirmNavigation);
    }
    }, [isDirty, isDirtyTwo, isDirtyThree, isDirtyFour]);

    useEffect(() => {
        if (_.isEmpty(errors) && isFormUpdate === true) {
            if (isDirty) {
                onValidateUser()
            }
            if (!isDirty) {
                onSaveDetails()
            }
            // else if(isDirtyTwo || isDirtyThree || isDirtyFour) {
            //     $("#save-account-details").modal("show");
            // }
            setIsFormUpdate(false)
        }
    }, [isDirty, isFormUpdate]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27 && isDirty === true) {
                // $("#save-personal-details").modal("show");
                onSaveDetails()
            }
        };
        window.addEventListener("keydown", handleEsc);
    }, [isDirty]);

    useEffect(() => {
        if (Object.keys(errors)?.length > 0 === false && submitValueOne === true) {
            setSelectedTabs(1);
            setSubmitValueOne(false);
        }
    }, [errors, submitValueOne]);

    useEffect(() => {
        if (errors.social_platform) {
            toast.open("Please link account first", "error")
        } else if (errors.account_handle) {
            toast.open("Please select your social platform", "error")
        }
    }, [errors])

    useEffect(() => {
        if (
            Object.keys(errorsTwo)?.length > 0 === false &&
            submitValueTwo === true
        ) {
            setSelectedTabs(2);
            setSubmitValueTwo(false);
        }
    }, [errorsTwo, submitValueTwo]);

    useEffect(() => {
        if (
            Object.keys(errorsThree)?.length > 0 === false &&
            submitValueThree === true
        ) {
            setSelectedTabs(3);
            setSubmitValueThree(false);
        }
    }, [errorsThree, submitValueThree]);

    useEffect(() => {
        if (
            Object.keys(errorsFour)?.length > 0 === false &&
            submitValueFour === true
        ) {
            onSaveDetails()
            setSubmitValueFour(false);
        }
    }, [errorsFour, submitValueFour]);

    useEffect(() => {
        onGetTabsTwoValue()
        onGetTabsThreeValue()
        onGetTabsFourValue()
    }, [selectedTabs])

    const onGetTabsTwoValue = async () => {
        if (selectedTabs === 1 && !tabTwoDataRestrict) {
            const language = await getLanguage().catch((e) => console.log("err", e));
            setDropDownValues((prevState) => ({ ...prevState, language: language?.data || [], }))
            setTabTwoDataRestrict(true)
        }
    }
    useEffect(() => {
        if (selectedTabs === 1 && tabTwoDataRestrict && !isDirtyTwo) {
            const { basic_info } = personalData?.data
            setValue("social_platform", platformData)
            setValueTwo("height_inch", inchesJSON.find(a => a.value === basic_info.height_inch))
            setValueTwo("height_feet", feetJSON.find(a => a.value === basic_info.height_feet))
            setValueTwo("weight", basic_info?.weight)
            const temp = basic_info?.dob?.split("-")
            if (temp) {
                setAgePicker(new Date(`${temp[1]}-${temp[0]}-${temp[2]}`))
                setValueTwo("dob", new Date(`${temp[1]}-${temp[0]}-${temp[2]}`))
            }
            setValueTwo("languages", dropDownValues?.language?.filter(a => basic_info?.languages_str?.includes(a.text)))
            setValueTwo("other_languages", basic_info?.other_languages || [])
        }
    }, [dropDownValues, selectedTabs, personalData, tabTwoDataRestrict])
    const onGetTabsThreeValue = async () => {
        if (selectedTabs === 2 && !tabThreeDataRestrict) {
            const hairColors = await getHairColors().catch((e) => console.log("err", e));
            const hair_length = await getHairLength().catch((e) => console.log("err", e));
            const hairType = await getHairType().catch((e) => console.log("err", e));
            const skinColors = await getSkinColors().catch((e) => console.log("err", e));
            const eyeColors = await getEyeColors().catch((e) => console.log("err", e));
            const strengths = await getStrengths().catch((e) => console.log("err", e));
            const voiceTypes = await getVoiceTypes().catch((e) => console.log("err", e));
            const bodyTypes = await getBodyTypes().catch((e) => console.log("err", e));
            const tattoosBodyParts = await getTattoosBodyParts().catch((e) => console.log("err", e));
            const birthmarkBodyParts = await getBirthmarkBodyParts().catch((e) => console.log("err", e));
            const piercingBodyParts = await getPiercingBodyParts().catch((e) => console.log("err", e));
            setDropDownValues((prevState) => ({
                ...prevState,
                hairColors: hairColors?.data || [],
                hairLength: hair_length?.data || [],
                hairType: hairType?.data || [],
                skinColors: skinColors?.data || [],
                eyeColors: eyeColors?.data || [],
                strengths: strengths?.data || [],
                voiceTypes: voiceTypes?.data || [],
                bodyTypes: bodyTypes?.data || [],
                tattoosBodyParts: tattoosBodyParts?.data || [],
                birthmarkBodyParts: birthmarkBodyParts?.data || [],
                piercingBodyParts: piercingBodyParts?.data || [],
            }))
            setTabThreeDataRestrict(true)
        }
    }
    useEffect(() => {
        if (selectedTabs === 2 && tabThreeDataRestrict && !isDirtyThree) {
            const { physical_attributes } = personalData?.data
            setValueThree("other_hair_length", physical_attributes?.other_hair_length?.split(",") || [])
            setValueThree("other_hair_color", physical_attributes?.other_hair_color?.split(",") || [])
            // setValueThree("other_hair_color", physical_attributes?.other_hair_color || "")
            setValueThree("other_piercing", physical_attributes?.other_piercing?.places_str?.split(',') || [])
            setValueThree("other_birthmark_moles", physical_attributes?.other_birthmark_moles?.places_str?.split(',') || [])
            setValueThree("other_tattoos", physical_attributes?.other_tattoos_str?.split(",") || [])
            setValueThree("hair_type", physical_attributes?.hair_type)
            setValueThree("hair_length", dropDownValues?.hairLength?.find(a => a.text === physical_attributes?.hair_length_str))
            setValueThree("hair_color", dropDownValues?.hairColors?.find(a => a.text === physical_attributes?.hair_color_str))
            setValueThree("voice_type", dropDownValues?.voiceTypes?.find(a => a.text === physical_attributes?.voice_type))
            setValueThree("strength", dropDownValues?.strengths?.find(a => a.text === physical_attributes?.strength))
            setValueThree("body_type", dropDownValues?.bodyTypes?.find(a => a.text === physical_attributes?.body_type))
            setValueThree("eye_color", dropDownValues?.eyeColors?.find(a => a.text === physical_attributes?.eye_color))
            setValueThree("skin_color", dropDownValues?.skinColors?.find(a => a.text === physical_attributes?.skin_color))
            setValueThree("count_tattoo", countJSON?.find(a => a.value === physical_attributes?.tattoos?.total_count?.toString()))
            setValueThree("count_mole", countJSON?.find(a => a.value === physical_attributes?.birthmark_moles?.total_count?.toString()))
            setValueThree("count_piercing", countJSON?.find(a => a.value === physical_attributes?.piercing?.total_count?.toString()))
            setValueThree("tattoos", dropDownValues?.tattoosBodyParts?.filter(a => physical_attributes?.tattoos?.places_str
                ?.includes(a.text)))
            setValueThree("piercing", dropDownValues?.piercingBodyParts?.filter(a => physical_attributes?.piercing?.places_str
                ?.includes(a.text)))
            setValueThree("birthmark_moles", dropDownValues?.birthmarkBodyParts?.filter(a => physical_attributes?.birthmark_moles?.places_str
                ?.includes(a.text)))
        }
    }, [dropDownValues, selectedTabs, personalData])
    const onGetTabsFourValue = async () => {
        if (selectedTabs === 3 && !tabFourDataRestrict) {
            const adjectives = await getAdjectives().catch((e) => console.log("err", e));
            const phoneBrands = await getPhoneBrands().catch((e) => console.log("err", e));
            const videoShootingTypes = await getVideoShootingTypes().catch((e) => console.log("err", e));
            const clothingStyles = await getClothingStyles().catch((e) => console.log("err", e));
            const foodPreferences = await getFoodPreferences().catch((e) => console.log("err", e));
            const bodyParts = await getBodyParts().catch((e) => console.log("err", e));
            const brand = await getBrand().catch((e) => console.log("err", e));
            const otherSkills = await getOtherSkills().catch((e) => console.log("err", e));
            const awards = await getAwards().catch((e) => console.log("err", e));

            setDropDownValues((prevState) => ({
                ...prevState,
                adjectives: adjectives?.data || [],
                phoneBrands: phoneBrands?.data || [],
                videoShootingTypes: videoShootingTypes?.data || [],
                clothingStyles: clothingStyles?.data || [],
                foodPreferences: foodPreferences?.data || [],
                bodyParts: bodyParts?.data || [],
                brand: brand?.data || [],
                otherSkills: otherSkills?.data || [],
                awards: awards?.data || [],
            }))
            setTabFourDataRestrict(true)
        }
    }
    useEffect(() => {
        if (selectedTabs === 3 && tabFourDataRestrict && !isDirtyFour) {
            const { personality_traits } = personalData?.data
            setValueFour("adjectives", dropDownValues?.adjectives?.filter(a => personality_traits?.adjectives_str?.includes(a.text)))
            setValueFour("associated_brands", personality_traits?.associated_brands || [])
            setValueFour("other_adjectives", personality_traits?.other_adjectives || [])
            setValueFour("other_phone_brand", personality_traits?.other_phone_brand || [])
            setValueFour("other_skills", personality_traits?.other_skills || [])
            setValueFour("awards", personality_traits?.awards || [])
            setValueFour("phone_brand", dropDownValues?.phoneBrands?.filter(a => personality_traits?.phone_brand_str?.includes(a.text)))
            setValueFour("preferred_clothings", dropDownValues?.clothingStyles?.filter(a => personality_traits?.preferred_clothings?.includes(a.text)))
            setValueFour("shooting_mode", dropDownValues?.videoShootingTypes?.filter(a => personality_traits?.shooting_mode?.includes(a.text)))
            setValueFour("food_preferences", dropDownValues?.foodPreferences?.find(a => a.text === personality_traits?.food_preferences))
        }
    }, [dropDownValues, selectedTabs, personalData])
    const onCheck = () => {
        let contructChannelName = channelName
            ?.split("/")
            ?.filter((n) => n)
            ?.slice(-1)
            .pop();
        contructChannelName = contructChannelName?.split("@")?.slice(-1).pop();
        return contructChannelName;
    };

    const onHandleKeyPress = (e) => {
        if (e.code === "Enter" && e.target.value != "" && validateDetail.detail_added) {
            setIsFormUpdate(true)
        } else if (e.code === "Enter" && e.target.value != "") {
            onValidateUser()
        }
    };

    const accountValidate = async () => {
        if (isDirty) {
            const payload = {
                platform: platformData.value,
                handleUser: onCheck()
            }
            if (!payload.platform || !payload?.handleUser) {
                return
            }
            setLoading(true)
            const check = await onCheckValidateAccount(payload)
            setLoading(false)
            if (check?.data?.valid_account) {
                toast.open("Account verified successfully")
                const liveProfileDetails = await getProfileDetails(check?.data?.publisher_id)
                setPersonalData(liveProfileDetails)
                setSubmitValueOne(true)
                return
            }

            resetTwo()
            resetThree()
            resetFour()
            setValidateDetail({})
            if (!check?.data?.valid_account) {
                toast.open("Please enter the correct account handle", "error")
                return
            }
            if (!check?.status) {
                return
            }
        }
    }

    const onSaveDetails = () => {
        if (isDirtyTwo && !isDirtyThree && !isDirtyFour || !isDirtyTwo && !isDirtyThree && !isDirtyFour) {
            var allSubmit = {
                ...basicDataFormData,
                publisher_id: validateDetail?.publisher_id,
                platform: accountFormData?.social_platform?.value,
                handleUser: onCheck(),
                weight: basicDataFormData?.weight?.toString(),
                languages: basicDataFormData?.languages?.map((e) => e.text)?.toString(),
                other_languages: basicDataFormData?.other_languages?.toString(),
                height_feet: basicDataFormData?.height_feet?.value?.toString(),
                height_inch: basicDataFormData?.height_inch?.value?.toString(),
                body_type: personalData?.data?.physical_attributes?.body_type,
                eye_color: personalData?.data?.physical_attributes?.eye_color,
                hair_type: personalData?.data?.physical_attributes?.hair_type,
                hair_color: personalData?.data?.physical_attributes?.hair_color_str,
                hair_length: personalData?.data?.physical_attributes?.hair_length_str,
                other_hair_color: personalData?.data?.physical_attributes?.other_hair_color_str || "",
                other_birthmark_moles: personalData?.data?.physical_attributes?.other_birthmark_moles_str || "",
                other_birthmark_moles_str: personalData?.data?.physical_attributes?.other_birthmark_moles_str || "",
                other_hair_length: personalData?.data?.physical_attributes?.other_hair_length_str || "",
                other_piercing: personalData?.data?.physical_attributes?.other_piercing_str || "",
                piercing: personalData?.data?.physical_attributes?.piercing_str,
                skin_color: personalData?.data?.physical_attributes?.skin_color,
                strength: personalData?.data?.physical_attributes?.strength,
                tattoos: personalData?.data?.physical_attributes?.tattoos_str,
                other_tattoos: personalData?.data?.physical_attributes?.other_tattoos_str || "",
                voice_type: personalData?.data?.physical_attributes?.voice_type,
                birthmark_moles: personalData?.data?.physical_attributes?.birthmark_moles_str,

                awards: personalData?.data?.personality_traits?.awards_str,
                other_skills: personalData?.data?.personality_traits?.other_skills_str,
                adjectives: personalData?.data?.personality_traits?.adjectives_str,
                associated_brands: personalData?.data?.personality_traits?.associated_brands?.toString(),
                food_preferences: personalData?.data?.personality_traits?.food_preferences,
                other_adjectives: personalData?.data?.personality_traits?.other_adjectives_str || "",
                other_phone_brand: personalData?.data?.personality_traits?.other_phone_brand_str || "",
                phone_brand: personalData?.data?.personality_traits?.phone_brand_str,
                preferred_clothings: personalData?.data?.personality_traits?.preferred_clothings_str,
                shooting_mode: personalData?.data?.personality_traits?.shooting_mode,
            }
        }
        else if (!isDirtyTwo && isDirtyThree && !isDirtyFour) {
            var allSubmit = {
                ...basicDataFormData,
                ...physicalFormData,
                publisher_id: validateDetail?.publisher_id,
                platform: accountFormData?.social_platform?.value,
                handleUser: onCheck(),
                weight: basicDataFormData?.weight?.toString(),
                languages: basicDataFormData?.languages?.map((e) => e.text)?.toString(),
                other_languages: basicDataFormData?.other_languages?.toString(),
                height_feet: basicDataFormData?.height_feet?.value?.toString(),
                height_inch: basicDataFormData?.height_inch?.value?.toString(),
                strength: physicalFormData?.strength?.text,
                eye_color: physicalFormData?.eye_color?.text,
                body_type: physicalFormData?.body_type?.text,
                hair_type: physicalFormData?.hair_type,
                hair_color: physicalFormData?.hair_color?.text,
                hair_length: physicalFormData?.hair_length?.text,
                other_hair_length: physicalFormData?.other_hair_length?.toString(),
                other_hair_color: physicalFormData?.other_hair_color?.toString(),
                other_piercing: physicalFormData?.other_piercing?.toString(),
                other_birthmark_moles: physicalFormData?.other_birthmark_moles?.toString(),
                other_tattoos: physicalFormData?.other_tattoos?.toString(),
                piercing: `${physicalFormData?.count_piercing?.value || ""}:${physicalFormData?.piercing
                    ?.map((e) => e.text)
                    .toString()}`,
                skin_color: physicalFormData?.skin_color?.text,
                tattoos: `${physicalFormData?.count_tattoo?.value || ""}:${physicalFormData?.tattoos
                    ?.map((e) => e.text)
                    .toString()}`,
                voice_type: physicalFormData?.voice_type?.text,
                birthmark_moles: `${physicalFormData?.count_mole?.value
                    || ""}:${physicalFormData?.birthmark_moles?.map((e) => e.text)?.toString()}`,

                awards: personalData?.data?.personality_traits?.awards_str,
                other_skills: personalData?.data?.personality_traits?.other_skills_str,
                adjectives: personalData?.data?.personality_traits?.adjectives_str,
                associated_brands: personalData?.data?.personality_traits?.associated_brands?.toString(),
                food_preferences: personalData?.data?.personality_traits?.food_preferences,
                other_adjectives: personalData?.data?.personality_traits?.other_adjectives_str || "",
                other_phone_brand: personalData?.data?.personality_traits?.other_phone_brand_str || "",
                phone_brand: personalData?.data?.personality_traits?.phone_brand_str,
                preferred_clothings: personalData?.data?.personality_traits?.preferred_clothings_str,
                shooting_mode: personalData?.data?.personality_traits?.shooting_mode,
            }
        } else if (!isDirtyTwo && !isDirtyThree && isDirtyFour) {
            var allSubmit = {
                ...basicDataFormData,
                ...personalFormData,
                publisher_id: validateDetail?.publisher_id,
                platform: accountFormData?.social_platform?.value,
                handleUser: onCheck(),
                weight: basicDataFormData?.weight?.toString(),
                languages: basicDataFormData?.languages?.map((e) => e.text)?.toString(),
                other_languages: basicDataFormData?.other_languages?.toString(),
                height_feet: basicDataFormData?.height_feet?.value?.toString(),
                height_inch: basicDataFormData?.height_inch?.value?.toString(),
                body_type: personalData?.data?.physical_attributes?.body_type,
                eye_color: personalData?.data?.physical_attributes?.eye_color,
                hair_type: personalData?.data?.physical_attributes?.hair_type,
                hair_color: personalData?.data?.physical_attributes?.hair_color_str,
                hair_length: personalData?.data?.physical_attributes?.hair_length_str,
                other_birthmark_moles_str: personalData?.data?.physical_attributes?.other_birthmark_moles_str || "",
                other_hair_length: personalData?.data?.physical_attributes?.other_hair_length_str || "",
                other_piercing: personalData?.data?.physical_attributes?.other_piercing_str || "",
                other_hair_color: personalData?.data?.physical_attributes?.other_hair_color_str || "",
                other_birthmark_moles: personalData?.data?.physical_attributes?.other_birthmark_moles_str || "",
                piercing: personalData?.data?.physical_attributes?.piercing_str,
                skin_color: personalData?.data?.physical_attributes?.skin_color,
                strength: personalData?.data?.physical_attributes?.strength,
                tattoos: personalData?.data?.physical_attributes?.tattoos_str,
                other_tattoos: personalData?.data?.physical_attributes?.other_tattoos_str || "",
                voice_type: personalData?.data?.physical_attributes?.voice_type,
                birthmark_moles: personalData?.data?.physical_attributes?.birthmark_moles_str,

                adjectives: personalFormData?.adjectives?.map((e) => e.text)?.toString(),
                associated_brands: personalFormData?.associated_brands?.toString(),
                preferred_clothings: personalFormData?.preferred_clothings?.map((e) => e.text)?.toString(),
                awards: personalFormData?.awards?.toString(),
                other_skills: personalFormData?.other_skills?.toString(),
                food_preferences: personalFormData?.food_preferences?.text,
                phone_brand: personalFormData?.phone_brand?.map((e) => e.text)?.toString(),
                shooting_mode: personalFormData?.shooting_mode?.map((e) => e.text)?.toString(),
                other_adjectives: personalFormData?.other_adjectives?.toString(),
                other_phone_brand: personalFormData?.other_phone_brand?.toString(),
            }
        }
        else {
            var allSubmit = {
                ...basicDataFormData,
                ...physicalFormData,
                ...personalFormData,
                publisher_id: validateDetail?.publisher_id,
                platform: accountFormData?.social_platform?.value,
                handleUser: onCheck(),
                languages: basicDataFormData?.languages?.map((e) => e.text).toString(),
                height_feet: basicDataFormData?.height_feet?.value?.toString(),
                height_inch: basicDataFormData?.height_inch?.value?.toString(),
                strength: physicalFormData?.strength?.text,
                eye_color: physicalFormData?.eye_color?.text,
                body_type: physicalFormData?.body_type?.text,
                hair_type: physicalFormData?.hair_type,
                hair_color: physicalFormData?.hair_color?.text,
                hair_length: physicalFormData?.hair_length?.text,
                piercing: `${physicalFormData?.count_piercing?.value || null}:${physicalFormData?.piercing
                    ?.map((e) => e.text)
                    .toString() || null}`,
                skin_color: physicalFormData?.skin_color?.text,
                tattoos: `${physicalFormData?.count_tattoo?.value || null}:${physicalFormData?.tattoos
                    ?.map((e) => e.text)
                    .toString() || null}`,
                voice_type: physicalFormData?.voice_type?.text,
                birthmark_moles: `${physicalFormData?.count_mole?.value
                    || null}:${physicalFormData?.birthmark_moles?.map((e) => e.text)?.toString() || null}`,
                adjectives: personalFormData?.adjectives?.map((e) => e.text)?.toString(),
                associated_brands: personalFormData?.associated_brands?.toString(),
                preferred_clothings: personalFormData?.preferred_clothings?.map((e) => e.text)?.toString(),
                awards: personalFormData?.awards?.toString(),
                other_skills: personalFormData?.other_skills?.toString(),
                food_preferences: personalFormData?.food_preferences.text,
                phone_brand: personalFormData?.phone_brand?.map((e) => e.text)?.toString(),
                shooting_mode: personalFormData?.shooting_mode?.map((e) => e.text)?.toString(),
                other_languages: basicDataFormData?.other_languages?.toString(),
                other_hair_color: physicalFormData?.other_hair_color?.toString(),
                other_hair_length: physicalFormData?.other_hair_length?.toString(),
                other_piercing: physicalFormData?.other_piercing?.toString(),
                other_birthmark_moles: physicalFormData?.other_birthmark_moles?.toString(),
                other_tattoos: physicalFormData?.other_tattoos?.toString(),
                other_adjectives: personalFormData?.other_adjectives?.toString(),
                other_phone_brand: personalFormData?.other_phone_brand?.toString(),
            };
        }
        delete allSubmit.count_mole;
        delete allSubmit.count_tattoo;
        delete allSubmit.count_piercing;
        if (validateDetail?.detail_added) {
            updatePersonalData(allSubmit).then(res => {
                reset();
                resetTwo();
                resetThree();
                resetFour();
                setValidateDetail({})
                setChannelName()
                if (isDirty) {
                    accountValidate()
                    return
                }
                toast.buttomOpen("Information saved successfully");
                setSelectedTabs(0);
            }).catch(err => console.log("err", err))
            return
        }
        addCreatorDetail(allSubmit).then(res => {
            reset();
            resetTwo();
            resetThree();
            resetFour();
            setValidateDetail({})
            setChannelName()
            toast.buttomOpen("Information added successfully");
            setSelectedTabs(0);
        }).catch(err => console.log("err", err))
    };

    const onValidateUser = async () => {
        const payload = {
            platform: accountFormData?.social_platform?.value,
            handleUser: onCheck()
        }
        if (!payload.platform || !payload?.handleUser) {
            return
        }
        setLoading(true)
        const check = await onCheckValidateAccount(payload)
        setLoading(false)
        if (!check?.data?.valid_account) {
            setValidateDetail({})
            toast.open("Please enter the correct account handle", "error")
            return
        }
        if (!check?.status) {
            return
        }
        setValidateDetail(check?.data)
        if (check?.data?.valid_account) {
            toast.open("Account verified successfully")
            const liveProfileDetails = await getProfileDetails(check?.data?.publisher_id)
            setPersonalData(liveProfileDetails)
            setSubmitValueOne(true)
            reset()
            return
        }
    }
    const handeFocus = () => {
        if (_.isEmpty(channelName)) {
            setChannelName(prefix)
        }
    }
    const onDisableTab = () => {
        if (!validateDetail?.valid_account) {
            toast.open("Please link account first", "error")
        }
    }

    const LogoutForm = async () => {
        try {
            setLoading(true);
            let response = await logOutPublicCreator();
            if (response.status) {
                history.push('/creator-landing');
            } else {
                history.push('/creator-form');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }
    const onHandleLogout = () => {
        $('#logout-personal-details').modal("show");
    }
    return (
        <>
            <div className="public-creator-form-wrap">
                {/* <img className='form-bg-img' src={formBg} alt="" /> */}
                <div className="public-creator-form">
                    <div className=" d-flex justify-content-between heading">Personal Details
                        <div className="common-btn">
                            <button className="btn-green btn-logout" onClick={validateDetail?.valid_account && (isDirtyTwo || isDirtyThree || isDirtyFour) ? onHandleLogout : LogoutForm}> Logout</button>
                        </div>
                    </div>

                    <div className="react-tab-wrap creator-tabs">
                        <Tabs
                            onSelect={(tabIndex) => setSelectedTabs(tabIndex)}
                            selectedIndex={
                                selectedTabs === 0
                                    ? 0
                                    : selectedTabs === 1
                                        ? 1
                                        : selectedTabs === 2
                                            ? 2
                                            : 3
                            }
                        >
                            <TabList>
                                <Tab>Link Account</Tab>
                                <Tab tabFor="one" disabled={!validateDetail?.valid_account} onClick={onDisableTab}>Basic Details</Tab>
                                <Tab tabFor="two" disabled={!validateDetail?.valid_account} onClick={onDisableTab}>Physical Attributes</Tab>
                                <Tab tabFor="three" disabled={!validateDetail?.valid_account} onClick={onDisableTab}> Personality Traits</Tab>
                                {/* <Tab tabFor="one" >Basic Details</Tab>
                                <Tab tabFor="two" >Physical Attributes</Tab>
                                <Tab tabFor="three" > Personality Traits</Tab> */}
                            </TabList>
                            <>
                                <form
                                    id="formOne"
                                    key={1}
                                    onSubmit={handleSubmit((data) => setLinkSubmit(data))}
                                >
                                    <TabPanel tabId="one">
                                        <div className="react-tab-content-wrap common-scroll">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon16} alt="" />Social Platform
                                                        </label>
                                                        <Controller
                                                            name="social_platform"
                                                            refs={register("social_platform", {
                                                                onChange: (e) => {
                                                                    setPlatform(e.target.value)
                                                                },
                                                            })}
                                                            render={({ field }) => (
                                                                <Select
                                                                    menuPosition="fixed"
                                                                    placeholder={"Select"}
                                                                    {...field}
                                                                    options={socialMediaOptions}
                                                                    isDisabled={validateDetail.detail_added}
                                                                    isSearchable={false}
                                                                    formatOptionLabel={formatOptionLabel}
                                                                    classNamePrefix="react-select"
                                                                />
                                                            )}
                                                            control={control}
                                                            defaultValue=""
                                                        />
                                                        {errors.social_platform && (
                                                            <p className="required">
                                                                {errors.social_platform.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon17} alt="" />Enter your account handle or URL
                                                        </label>
                                                        <Controller
                                                            name="account_handle"
                                                            control={control}
                                                            render={({ field: { value, onChange, ...field } }) => (
                                                                <input
                                                                    {...register("account_handle")}
                                                                    onKeyDown={onHandleKeyPress}
                                                                    {...field}
                                                                    onFocus={handeFocus}
                                                                    value={channelName}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;
                                                                        if (isValidUrl(input)) {
                                                                            e.target.value = input;
                                                                        } else {
                                                                            setChannelName((prev) => {
                                                                                if (prefix === e.target.value) {
                                                                                    e.target.value = prefix;
                                                                                } else if (prev.length === 0) {
                                                                                    e.target.value = prefix + input;
                                                                                } else {
                                                                                    e.target.value = prefix;
                                                                                    if (input.length > 0) {
                                                                                        e.target.value =
                                                                                            prefix + input.substr(prefix.length);
                                                                                    } else {
                                                                                        e.target.value = "";
                                                                                    }
                                                                                }
                                                                                onValueChange(e.target.value);
                                                                                return;
                                                                            });
                                                                        }
                                                                        onValueChange(e.target.value);
                                                                        onChange(e.target.value);
                                                                    }}
                                                                    disabled={validateDetail.detail_added}
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="account_handle"
                                                                    placeholder="Enter your account handle associated with your selected platform"
                                                                />
                                                            )}
                                                        />

                                                        {errors.account_handle && (
                                                            <p className="required">
                                                                {errors.account_handle.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </form>
                                <form
                                    id="formTwo"
                                    key={2}
                                    onSubmit={handleSubmitTwo((data) => setBasicSubmit(data))}
                                >
                                    <TabPanel tabId="two">
                                        <div className="react-tab-content-wrap common-scroll">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap custom-select-mui">
                                                        <label htmlFor="">
                                                            {" "}
                                                            <img src={formIcon1} alt="" /> Height{" "}
                                                        </label>
                                                        <Controller
                                                            name="height_feet"
                                                            refs={registerTwo("height_feet")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    menuPosition="fixed"
                                                                    placeholder={"Height feet"}
                                                                    {...field}
                                                                    options={feetJSON}
                                                                    styles={customStyles}
                                                                />
                                                            )}
                                                            control={controlTwo}
                                                            defaultValue=""
                                                        />
                                                        {errorsTwo.height_feet && (
                                                            <p className="required">
                                                                {errorsTwo.height_feet.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap custom-select-mui scale-mark-mob">
                                                        <label className="lable-blank" htmlFor="">&nbsp;</label>
                                                        <Controller
                                                            name="height_inch"
                                                            refs={registerTwo("height_inch")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    menuPosition="fixed"
                                                                    placeholder={"Height inch"}
                                                                    {...field}
                                                                    options={inchesJSON}
                                                                />
                                                            )}
                                                            control={controlTwo}
                                                            defaultValue=""
                                                        />
                                                        {errorsTwo.height_inch && (
                                                            <p className="required">
                                                                {errorsTwo.height_inch.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-10">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            {" "}
                                                            <img src={formIcon2} alt="" />Weight
                                                        </label>
                                                        <input
                                                            {...registerTwo("weight")}
                                                            className="form-control"
                                                            type="number"
                                                            onKeyDown={(evt) => ["e", "E"].includes(evt.key) && evt.preventDefault()}
                                                            name="weight"
                                                            placeholder="Enter your weight (in kg)"
                                                        />
                                                        {errorsTwo.weight && (
                                                            <p className="required">
                                                                {errorsTwo.weight.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-10">
                                                    <div
                                                        className="input-label-wrap"
                                                        data-toggle="modal"
                                                        data-target="#open-date-picker"
                                                    >
                                                        <label htmlFor="">
                                                            <img src={formIcon3} alt="" /> How old are you?
                                                        </label>
                                                        <input
                                                            value={
                                                                agePicker
                                                                    ? moment(agePicker).format("DD-MM-YYYY")
                                                                    : ""
                                                            }
                                                            className="form-control"
                                                            type="text"
                                                            autoComplete="off"
                                                            name="dob"
                                                            placeholder="Enter your date of birth"
                                                        />
                                                        <img
                                                            className="calender-mark"
                                                            src={CalenderMark}
                                                            alt=""
                                                        />
                                                        {errorsTwo.dob && (
                                                            <p className="required">
                                                                {errorsTwo.dob.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-10">
                                                    <div className="input-label-wrap">
                                                        <label className="" htmlFor="">
                                                            ️<img src={formIcon4} alt="" />Which languages do  you prefer to speak in?
                                                        </label>
                                                        <Controller
                                                            refs={registerTwo("languages")}
                                                            name="languages"
                                                            render={({ field }) => (
                                                                <Select
                                                                    menuPosition="fixed"
                                                                    placeholder={
                                                                        "Enter your preferred language"
                                                                    }
                                                                    {...field}
                                                                    isMulti
                                                                    classNamePrefix="react-select"
                                                                    isClearable={false}
                                                                    options={dropDownValues?.language}
                                                                    getOptionLabel={(option) => option.text}
                                                                    styles={customStyles}
                                                                />
                                                            )}
                                                            control={controlTwo}
                                                            defaultValue=""
                                                        />
                                                        {errorsTwo.languages && (
                                                            <p className="required">
                                                                {errorsTwo.languages.message}
                                                            </p>
                                                        )}
                                                    </div>

                                                    {basicDataFormData?.languages?.some(a => a.value === "other") &&
                                                        <div className="input-label-wrap others-label">
                                                            <Controller
                                                                refs={registerTwo("other_languages")}
                                                                name="other_languages"
                                                                control={controlTwo}
                                                                render={({ field }) => (
                                                                    <MuiChipsInput
                                                                        autoComplete="off"
                                                                        hideClearAll
                                                                        renderChip={(Component, key, props) => {
                                                                            return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                        }}
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder={getValuesTwo("other_languages")?.length === 0 || getValuesTwo("other_languages") === undefined ? "Other (Please Specify)" : false}
                                                                        addOnWhichKey={[",", "Enter"]}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    </TabPanel>
                                </form>
                                <form
                                    id="formThree"
                                    key={3}
                                    onSubmit={handleSubmitThree((data) =>
                                        setPhysicalSubmit(data)
                                    )}
                                >
                                    <TabPanel tabId="three">
                                        <div className="react-tab-content-wrap common-scroll">
                                            <div className="row">
                                                <div className="col-md-10">
                                                    <div className="input-label-wrap first-heading">
                                                        <label htmlFor="">
                                                            {" "}
                                                            <img src={formIcon5} alt="" />Hair Type
                                                            {/* Hover Tooltip UI for Labels */}
                                                            <div className="custom-tool-tip">
                                                                <div className="tooltip-overlay"></div>
                                                                <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                    className="more-btn-brand"
                                                                    href="javascript:void(0)"
                                                                >
                                                                    <img src={TooltipIcon} alt="tool" />
                                                                    <div className="right_tooltip">
                                                                        <div
                                                                            className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                            aria-labelledby="dropdownMenuButton "
                                                                        >
                                                                            <div className="tooltip-heading">
                                                                                <span>Hair type</span>
                                                                            </div>
                                                                            <div className="dropdown-wrap-area common-scroll">
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Curly<b>-</b> </span>
                                                                                    Curved or spiral in shape
                                                                                </a>
                                                                                <a href="javascript:void(0);" >
                                                                                    <span>Coily<b>-</b> </span>
                                                                                    small, tight curls, or zigzag-shaped hairs with more defined ringlets
                                                                                </a>
                                                                                <a href="javascript:void(0);" >
                                                                                    <span>Straight<b>-</b> </span>
                                                                                    Fine threads, does not curl easily with no bend or curve
                                                                                </a>
                                                                                <a href="javascript:void(0);" >
                                                                                    <span> Waivy<b>-</b> </span>
                                                                                    generally straight-looking at the top, then falling down in a tousled look (s-shaped)
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* Hover Tooltip UI for Labels */}
                                                        </label>
                                                        <div className="radio-button-wrap">
                                                            <div className="custom-radio-btn">
                                                                {dropDownValues?.hairType?.map((obj, key) => {
                                                                    return (
                                                                        <div className="radio-buttons" key={key}>
                                                                            <input
                                                                                {...registerThree("hair_type")}
                                                                                type="radio"
                                                                                id={obj.text}
                                                                                value={obj.text}
                                                                            />
                                                                            <label for={obj.text}>{obj.text}</label>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                            {errorsThree.hair_type && (
                                                                <p className="required">
                                                                    {errorsThree.hair_type.message}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon6} alt="" />Hair Color
                                                        </label>
                                                        <Controller
                                                            name="hair_color"
                                                            refs={registerThree("hair_color")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Enter your hair color"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.hairColors}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.hair_color && (
                                                            <p className="required">
                                                                {errorsThree.hair_color.message}
                                                            </p>
                                                        )}
                                                    </div>

                                                    {physicalFormData?.hair_color?.value === "other" &&
                                                        <div class="input-label-wrap others-label">

                                                            <Controller
                                                                refs={registerThree("other_hair_color")}
                                                                name="other_hair_color"
                                                                control={controlThree}
                                                                render={({ field }) => (
                                                                    <MuiChipsInput
                                                                        autoComplete="off"
                                                                        hideClearAll
                                                                        renderChip={(Component, key, props) => {
                                                                            return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                        }}
                                                                        addOnWhichKey={[",", "Enter"]}
                                                                        type="text"
                                                                        placeholder={getValuesThree("other_hair_color")?.length === 0 || getValuesThree("other_hair_color") === undefined ? "Other (Please Specify)" : false}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            />
                                                        </div>}
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon7} alt="" />Hair Length
                                                        </label>
                                                        <Controller
                                                            name="hair_length"
                                                            refs={registerThree("hair_length")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Enter your hair length"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.hairLength}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.hair_length && (
                                                            <p className="required">
                                                                {errorsThree.hair_length.message}
                                                            </p>
                                                        )}
                                                    </div>

                                                    {physicalFormData?.hair_length?.value === "other" &&
                                                        <div class="input-label-wrap others-label">
                                                            <Controller
                                                                refs={registerThree("other_hair_length")}
                                                                control={controlThree}
                                                                name="other_hair_length"

                                                                render={({ field }) => (
                                                                    <MuiChipsInput
                                                                        autoComplete="off"
                                                                        hideClearAll
                                                                        renderChip={(Component, key, props) => {
                                                                            return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                        }} onKeyPress={(e) => {
                                                                            if (e.key === ",") {
                                                                                e.preventDefault();
                                                                            }
                                                                        }}
                                                                        addOnWhichKey={[",", "Enter"]}
                                                                        type="text"
                                                                        name="other_hair_length"
                                                                        placeholder={getValuesThree("other_hair_length")?.length === 0 || getValuesThree("other_hair_length") === undefined ? "Other (Please Specify)" : false}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            />
                                                        </div>}
                                                </div>
                                            </div>


                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap custom-select-mui scale-mark-mob">
                                                        <label htmlFor="">
                                                            <img src={formIcon8} alt="" />‍️How many tattoos do you have?
                                                        </label>
                                                        <Controller
                                                            name="count_tattoo"
                                                            refs={registerThree("count_tattoo")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    menuPosition="fixed"
                                                                    placeholder={"Select quantity"}
                                                                    {...field}
                                                                    options={countJSON}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.count_tattoo && (
                                                            <p className="required">
                                                                {errorsThree.count_tattoo.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label className="lable-blank" htmlFor="">&nbsp;</label>
                                                        <Controller

                                                            name="tattoos"
                                                            refs={registerThree("tattoos")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    onKeyDown={(e) => {
                                                                        if ((parseInt(getValuesThree("count_tattoo")?.value) === 0)) {
                                                                            e.preventDefault()
                                                                            return
                                                                        }
                                                                    }
                                                                    }
                                                                    menuPosition="fixed"
                                                                    placeholder={"Select places you have tattoos"}
                                                                    {...field}
                                                                    isMulti
                                                                    classNamePrefix="react-select"
                                                                    isClearable={false}
                                                                    options={dropDownValues?.tattoosBodyParts}
                                                                    getOptionLabel={(option) => option.text}
                                                                    isDisabled={parseInt(physicalFormData?.count_tattoo?.value) === 0 || physicalFormData?.count_tattoo?.value === undefined}
                                                                    isOptionDisabled={() => physicalFormData?.count_tattoo?.value <= physicalFormData?.tattoos?.length || (physicalFormData?.tattoos?.some(a => a.value === "other") ? physicalFormData?.tattoos?.length - 1 + physicalFormData?.other_tattoos?.length === parseInt(physicalFormData?.count_tattoo?.value) : false)}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.tattoos && (
                                                            <p className="required">
                                                                {errorsThree.tattoos.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-10">
                                                    {physicalFormData?.tattoos?.some(a => a.value === "other") && <div class="input-label-wrap others-label">
                                                        <Controller
                                                            refs={registerThree("other_tattoos")}
                                                            control={controlThree}
                                                            name="other_tattoos"
                                                            render={({ field }) => (
                                                                <MuiChipsInput
                                                                    autoComplete="off"
                                                                    hideClearAll
                                                                    renderChip={(Component, key, props) => {
                                                                        return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                    }}
                                                                    addOnWhichKey={[",", "Enter"]}
                                                                    className={parseInt(getValuesThree("count_tattoo")?.value) <= getValuesThree("other_tattoos")?.length + (getValuesThree("tattoos")?.length - 1) ? 'blinking-cursor' : ''}
                                                                    type="text"
                                                                    placeholder={getValuesThree("other_tattoos")?.length === 0 || getValuesThree("other_tattoos") === undefined ? "Others (please specify)" : false}
                                                                    {...field}
                                                                    styles={{ caretColor: "transparent" }}
                                                                    onKeyDown={(e) => {
                                                                        if ((parseInt(getValuesThree("count_tattoo")?.value)
                                                                            <= getValuesThree("other_tattoos")?.length + (getValuesThree("tattoos")?.length - 1))) {
                                                                            e.preventDefault()
                                                                            return
                                                                        }
                                                                    }
                                                                    }
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap custom-select-mui scale-mark-mob">
                                                        <label htmlFor="">
                                                            <img src={formIcon9} alt="" />‍How many piercings do you have?
                                                            {/* Hover Tooltip UI for Labels */}
                                                            <div className="custom-tool-tip">
                                                                <div className="tooltip-overlay"></div>
                                                                <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                    className="more-btn-brand"
                                                                    href="javascript:void(0)"
                                                                >
                                                                    <img src={TooltipIcon} alt="tool" />
                                                                    <div className="right_tooltip">
                                                                        <div
                                                                            className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                            aria-labelledby="dropdownMenuButton "
                                                                        >
                                                                            <div className="tooltip-heading">
                                                                                <span>Piercing</span>
                                                                            </div>
                                                                            <div className="dropdown-wrap-area common-scroll">
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Piercing<b>-</b> </span>
                                                                                    Any holes, slots and notches in your body with a ring or stud, that is attached to pierced flesh
                                                                                </a>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* Hover Tooltip UI for Labels */}
                                                        </label>
                                                        <Controller
                                                            name="count_piercing"
                                                            refs={registerThree("count_piercing")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    menuPosition="fixed"
                                                                    placeholder={"Select quantity"}
                                                                    {...field}
                                                                    options={countJSON}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.count_piercing && (
                                                            <p className="required">
                                                                {errorsThree.count_piercing.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label className="lable-blank" htmlFor="">&nbsp;</label>
                                                        <Controller
                                                            name="piercing"
                                                            refs={registerThree("piercing")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    onKeyDown={(e) => {
                                                                        if ((parseInt(getValuesThree("count_piercing")?.value) === 0)) {
                                                                            e.preventDefault()
                                                                            return
                                                                        }
                                                                    }
                                                                    }
                                                                    menuPosition="fixed"
                                                                    placeholder={"Select places you have piercing"}
                                                                    {...field}
                                                                    isMulti
                                                                    isDisabled={parseInt(physicalFormData?.count_piercing?.value) === 0 || physicalFormData?.count_piercing?.value === undefined}
                                                                    isOptionDisabled={() => physicalFormData?.count_piercing?.value <= physicalFormData?.piercing?.length || (physicalFormData?.piercing?.some(a => a.value === "other") ? physicalFormData?.piercing?.length - 1 + physicalFormData?.other_piercing?.length === parseInt(physicalFormData?.count_piercing?.value) : false)}
                                                                    classNamePrefix="react-select"
                                                                    isClearable={false}
                                                                    options={dropDownValues?.piercingBodyParts}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.piercing && (
                                                            <p className="required">
                                                                {errorsThree.piercing.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                {physicalFormData?.piercing?.some(a => a.value === "other") && <div className="col-md-10">
                                                    <div class="input-label-wrap others-label">
                                                        <Controller
                                                            refs={registerThree("other_piercing")}
                                                            control={controlThree}
                                                            name="other_piercing"
                                                            render={({ field }) => (
                                                                <MuiChipsInput
                                                                    autoComplete="off"
                                                                    hideClearAll
                                                                    renderChip={(Component, key, props) => {
                                                                        return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                    }}
                                                                    className={parseInt(getValuesThree("count_piercing")?.value) <= getValuesThree("other_piercing")?.length + (getValuesThree("piercing")?.length - 1) ? 'blinking-cursor' : ''}
                                                                    onKeyDown={(e) => {
                                                                        if ((parseInt(getValuesThree("count_piercing")?.value) <= getValuesThree("other_piercing")?.length + (getValuesThree("piercing")?.length - 1))) {
                                                                            e.preventDefault()
                                                                            return
                                                                        }
                                                                    }
                                                                    }
                                                                    addOnWhichKey={[",", "Enter"]}
                                                                    {...registerThree("other_piercing")}
                                                                    type="text"
                                                                    placeholder={getValuesThree("other_piercing")?.length === 0 || getValuesThree("other_piercing") === undefined ? "Others (please specify)" : false}
                                                                    {...field}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap custom-select-mui scale-mark-mob">
                                                        <label htmlFor="">
                                                            <img src={formIcon10} alt="" />‍️How many moles do you have?
                                                            {/* Hover Tooltip UI for Labels */}
                                                            <div className="custom-tool-tip">
                                                                <div className="tooltip-overlay"></div>
                                                                <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                    className="more-btn-brand"
                                                                    href="javascript:void(0)"
                                                                >
                                                                    <img src={TooltipIcon} alt="tool" />
                                                                    <div className="right_tooltip">
                                                                        <div
                                                                            className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                            aria-labelledby="dropdownMenuButton "
                                                                        >
                                                                            <div className="tooltip-heading">
                                                                                <span>Moles</span>
                                                                            </div>
                                                                            <div className="dropdown-wrap-area common-scroll">
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Mole<b>-</b> </span>
                                                                                    Moles are growth on the skin that are usually brown or black, it can be multiple in no.
                                                                                </a>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* Hover Tooltip UI for Labels */}
                                                        </label>
                                                        <Controller
                                                            name="count_mole"
                                                            refs={registerThree("count_mole")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    menuPosition="fixed"
                                                                    placeholder={"Select quantity"}
                                                                    {...field}
                                                                    options={countJSON}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.count_mole && (
                                                            <p className="required">
                                                                {errorsThree.count_mole.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label className="lable-blank" htmlFor="">&nbsp;</label>
                                                        <Controller
                                                            name="birthmark_moles"
                                                            refs={registerThree("birthmark_moles")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Select places you have moles"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    onKeyDown={(e) => {
                                                                        if ((parseInt(getValuesThree("count_mole")?.value) === 0)) {
                                                                            e.preventDefault()
                                                                            return
                                                                        }
                                                                    }
                                                                    }

                                                                    options={dropDownValues?.birthmarkBodyParts}
                                                                    isDisabled={parseInt(physicalFormData?.count_mole?.value) === 0 || physicalFormData?.count_mole?.value === undefined}
                                                                    isOptionDisabled={() => physicalFormData?.count_mole?.value <= physicalFormData?.birthmark_moles?.length || (physicalFormData?.birthmark_moles?.some(a => a.value === "other") ? physicalFormData?.birthmark_moles?.length - 1 + physicalFormData?.other_birthmark_moles?.length === parseInt(physicalFormData?.count_mole?.value) : false)}
                                                                    getOptionLabel={(option) => option.text}
                                                                    isMulti
                                                                    classNamePrefix="react-select"
                                                                    isClearable={false}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.birthmark_moles && (
                                                            <p className="required">
                                                                {errorsThree.birthmark_moles.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                {physicalFormData?.birthmark_moles?.some(a => a.value === "other") && <div className="col-md-10">
                                                    <div class="input-label-wrap others-label">
                                                        <Controller
                                                            refs={registerThree("other_birthmark_moles")}
                                                            name="other_birthmark_moles"
                                                            control={controlThree}
                                                            render={({ field }) => (
                                                                <MuiChipsInput
                                                                    hideClearAll
                                                                    renderChip={(Component, key, props) => {
                                                                        return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                    }}
                                                                    type="text"
                                                                    className={parseInt(getValuesThree("count_mole")?.value) <= getValuesThree("other_birthmark_moles")?.length + (getValuesThree("birthmark_moles")?.length - 1) ? 'blinking-cursor' : ''}
                                                                    onKeyDown={(e) => {
                                                                        if ((parseInt(getValuesThree("count_mole")?.value) <= getValuesThree("other_birthmark_moles")?.length + (getValuesThree("birthmark_moles")?.length - 1))) {
                                                                            e.preventDefault()
                                                                            return
                                                                        }
                                                                    }
                                                                    }
                                                                    placeholder={getValuesThree("other_birthmark_moles")?.length === 0 || getValuesThree("other_birthmark_moles") === undefined ? "Others (please specify)" : false}
                                                                    addOnWhichKey={[",", "Enter"]}
                                                                    autoComplete="off"
                                                                    {...field}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>}
                                            </div>


                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon11} alt="" />Skin Color
                                                        </label>
                                                        <Controller
                                                            name="skin_color"
                                                            refs={registerThree("skin_color")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Enter your skin color"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.skinColors}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.skin_color && (
                                                            <p className="required">
                                                                {errorsThree.skin_color.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon12} alt="" />Eye Color
                                                        </label>
                                                        {/* <input className="form-control" type="text" placeholder="Other (please specify)" /> */}
                                                        <Controller
                                                            name="eye_color"
                                                            refs={registerThree("eye_color")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Enter your eye color"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.eyeColors}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.eye_color && (
                                                            <p className="required">
                                                                {errorsThree.eye_color.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon13} alt="" />Body Type
                                                            {/* Hover Tooltip UI for Labels */}
                                                            <div className="custom-tool-tip tooltip-bottom-side">
                                                                <div className="tooltip-overlay"></div>
                                                                <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                    className="more-btn-brand"
                                                                    href="javascript:void(0)"
                                                                >
                                                                    <img src={TooltipIcon} alt="tool" />
                                                                    <div className="right_tooltip">
                                                                        <div
                                                                            className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                            aria-labelledby="dropdownMenuButton "
                                                                        >
                                                                            <div className="tooltip-heading">
                                                                                <span>Body Type</span>
                                                                            </div>
                                                                            <div className="dropdown-wrap-area common-scroll">
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Curvy<b>-</b> </span>
                                                                                    fuller, rounder figures of all proportions
                                                                                </a>
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Athletic<b>-</b> </span>

                                                                                    muscular body and well-built shoulders
                                                                                </a>
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Hourglass<b>-</b> </span>
                                                                                    top and bottom halves of the body are equally broad
                                                                                </a>
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Oval<b>-</b> </span>
                                                                                    top and bottom halves of the body are narrow.
                                                                                </a>
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Pear<b>-</b> </span>
                                                                                    narrower shoulders than hips
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* Hover Tooltip UI for Labels */}
                                                        </label>
                                                        <Controller
                                                            name="body_type"
                                                            refs={registerThree("body_type")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Enter your body type"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.bodyTypes}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.body_type && (
                                                            <p className="required">
                                                                {errorsThree.body_type.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon14} alt="" />Strength
                                                        </label>
                                                        <Controller
                                                            name="strength"
                                                            refs={registerThree("strength")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Enter your Body Physique"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.strengths}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.strength && (
                                                            <p className="required">
                                                                {errorsThree.strength.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon15} alt="" />Voice Type
                                                            {/* Hover Tooltip UI for Labels */}
                                                            <div className="custom-tool-tip tooltip-bottom-side">
                                                                <div className="tooltip-overlay"></div>
                                                                <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                    className="more-btn-brand"
                                                                    href="javascript:void(0)"
                                                                >
                                                                    <img src={TooltipIcon} alt="tool" />
                                                                    <div className="right_tooltip">
                                                                        <div
                                                                            className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                            aria-labelledby="dropdownMenuButton "
                                                                        >
                                                                            <div className="tooltip-heading">
                                                                                <span>Voice Type</span>
                                                                            </div>
                                                                            <div className="dropdown-wrap-area common-scroll">
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Shrill<b>-</b> </span>
                                                                                    very loud and high
                                                                                </a>
                                                                                <a href="javascript:void(0);">
                                                                                    <span>High pitch<b>-</b> </span>

                                                                                    higher in volume or tone than usual
                                                                                </a>
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Low pitch<b>-</b> </span>
                                                                                    very soft and quiet
                                                                                </a>
                                                                                <a href="javascript:void(0);">
                                                                                    <span>Husky<b>-</b> </span>
                                                                                    having a semi-whispered vocal tone; sound breathy, raspy, or strained, somewhat hoarse
                                                                                </a>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* Hover Tooltip UI for Labels */}
                                                        </label>
                                                        <Controller
                                                            name="voice_type"
                                                            refs={registerThree("voice_type")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Enter your voice Type"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.voiceTypes}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlThree}
                                                            defaultValue=""
                                                        />
                                                        {errorsThree.voice_type && (
                                                            <p className="required">
                                                                {errorsThree.voice_type.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </form>
                                <form
                                    id="formFour"
                                    key={4}
                                    onSubmit={handleSubmitFour((data) =>
                                        setPersonalitySubmit(data)
                                    )}
                                >
                                    <TabPanel tabId="four">
                                        <div className="react-tab-content-wrap common-scroll">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon18} alt="" />Adjectives that best describe you{" "}
                                                            {/* Hover Tooltip UI for Labels */}
                                                            <div className="custom-tool-tip">
                                                                <div className="tooltip-overlay"></div>
                                                                <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                    className="more-btn-brand"
                                                                    href="javascript:void(0)"
                                                                >
                                                                    <img src={TooltipIcon} alt="tool" />
                                                                    <div className="right_tooltip">
                                                                        <div
                                                                            className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                            aria-labelledby="dropdownMenuButton "
                                                                        >
                                                                            <div className="tooltip-heading">
                                                                                <span>Adjectives that best describe you</span>
                                                                            </div>
                                                                            <div className="dropdown-wrap-area common-scroll">
                                                                                <a href="javascript:void(0);">
                                                                                    {/* <span> <b>-</b> </span> */}
                                                                                    Intangible words/phrases that help describe your personality
                                                                                </a>


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* Hover Tooltip UI for Labels */}
                                                        </label>
                                                        <Controller
                                                            name="adjectives"
                                                            refs={registerFour("adjectives")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={
                                                                        "Select your prefered adjectives"
                                                                    }
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.adjectives}
                                                                    getOptionLabel={(option) => option.text}
                                                                    isMulti
                                                                    classNamePrefix="react-select"
                                                                    isClearable={false}
                                                                />
                                                            )}
                                                            control={controlFour}
                                                            defaultValue=""
                                                        />
                                                        {errorsFour.adjectives && (
                                                            <p className="required">
                                                                {errorsFour.adjectives.message}
                                                            </p>
                                                        )}
                                                    </div>

                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon19} alt="" />Brands you've worked with
                                                            {/* Hover Tooltip UI for Labels */}
                                                            <div className="custom-tool-tip tooltip-right-side">
                                                                <div className="tooltip-overlay"></div>
                                                                <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                    className="more-btn-brand"
                                                                    href="javascript:void(0)"
                                                                >
                                                                    <img src={TooltipIcon} alt="tool" />
                                                                    <div className="right_tooltip">
                                                                        <div
                                                                            className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                            aria-labelledby="dropdownMenuButton "
                                                                        >
                                                                            <div className="tooltip-heading">
                                                                                <span>Brands you've worked with</span>
                                                                            </div>
                                                                            <div className="dropdown-wrap-area common-scroll">
                                                                                <a href="javascript:void(0);">
                                                                                    {/* <span> <b>-</b> </span> */}
                                                                                    Official paid brand collaborations. Eg. Fashion brand collabs
                                                                                </a>


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* Hover Tooltip UI for Labels */}
                                                        </label>
                                                        <Controller
                                                            refs={registerFour("associated_brands")}
                                                            name="associated_brands"
                                                            control={controlFour}
                                                            render={({ field }) => (
                                                                <MuiChipsInput
                                                                    autoComplete="off"
                                                                    hideClearAll
                                                                    renderChip={(Component, key, props) => {
                                                                        return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                    }}
                                                                    addOnWhichKey={[",", "Enter"]}
                                                                    type="text"
                                                                    name="associated_brands"
                                                                    placeholder={getValuesFour("associated_brands")?.length === 0 || getValuesFour("associated_brands") === undefined ? "Enter the name of the brands" : false}
                                                                    {...field}
                                                                />
                                                            )}
                                                        />
                                                        {errorsFour.associated_brands && (
                                                            <p className="required">
                                                                {errorsFour.associated_brands.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    {personalFormData?.adjectives?.some(a => a.value === "other") &&
                                                        <div class="input-label-wrap others-label">
                                                            <Controller
                                                                refs={registerFour("other_adjectives")}
                                                                name="other_adjectives"
                                                                control={controlFour}
                                                                render={({ field }) => (
                                                                    <MuiChipsInput
                                                                        autoComplete="off"
                                                                        hideClearAll
                                                                        renderChip={(Component, key, props) => {
                                                                            return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                        }}
                                                                        addOnWhichKey={[",", "Enter"]}
                                                                        type="text"
                                                                        name="other_adjectives"
                                                                        placeholder={getValuesFour("other_adjectives")?.length === 0 || getValuesFour("other_adjectives") === undefined ? "Other (Please Specify)" : false}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon20} alt="" />Other Skills
                                                            {/* Hover Tooltip UI for Labels */}
                                                            <div className="custom-tool-tip">
                                                                <div className="tooltip-overlay"></div>
                                                                <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                    className="more-btn-brand"
                                                                    href="javascript:void(0)"
                                                                >
                                                                    <img src={TooltipIcon} alt="tool" />
                                                                    <div className="right_tooltip">
                                                                        <div
                                                                            className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                            aria-labelledby="dropdownMenuButton "
                                                                        >
                                                                            <div className="tooltip-heading">
                                                                                <span>Other Skills</span>
                                                                            </div>
                                                                            <div className="dropdown-wrap-area common-scroll">
                                                                                <a href="javascript:void(0);">
                                                                                    {/* <span> <b>-</b> </span> */}
                                                                                    A learned power developed via aptitude or ability. Eg. time management, teamwork and leadership etc
                                                                                </a>


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* Hover Tooltip UI for Labels */}
                                                        </label>
                                                        <Controller
                                                            refs={registerFour("other_skills")}
                                                            name="other_skills"
                                                            control={controlFour}
                                                            render={({ field }) => (
                                                                <MuiChipsInput
                                                                    autoComplete="off"
                                                                    hideClearAll
                                                                    renderChip={(Component, key, props) => {
                                                                        return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                    }}
                                                                    addOnWhichKey={[",", "Enter"]}
                                                                    type="text"
                                                                    name="other_skills"
                                                                    placeholder={getValuesFour("other_skills")?.length === 0 || getValuesFour("other_skills") === undefined ? "Enter your skills here" : null}
                                                                    {...field}
                                                                />
                                                            )}
                                                        />
                                                        {errorsFour.other_skills && (
                                                            <p className="required">
                                                                {errorsFour.other_skills.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            ‍<img src={formIcon21} alt="" />Awards / Recognition received
                                                            {/* Hover Tooltip UI for Labels */}
                                                            <div className="custom-tool-tip tooltip-right-side">
                                                                <div className="tooltip-overlay"></div>
                                                                <a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                                    className="more-btn-brand"
                                                                    href="javascript:void(0)"
                                                                >
                                                                    <img src={TooltipIcon} alt="tool" />
                                                                    <div className="right_tooltip">
                                                                        <div
                                                                            className="dropdown-menu dropdown-toggle more-dropdown-brand"
                                                                            aria-labelledby="dropdownMenuButton "
                                                                        >
                                                                            <div className="tooltip-heading">
                                                                                <span>Awards / Recognition received</span>
                                                                            </div>
                                                                            <div className="dropdown-wrap-area common-scroll">
                                                                                <a href="javascript:void(0);">
                                                                                    {/* <span> <b>-</b> </span> */}
                                                                                    A tangible form of appreciation given for your contribution or accomplishment. Eg. Best Influencer award by xyz brand, dada saheb phalke award etc
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            {/* Hover Tooltip UI for Labels */}
                                                        </label>
                                                        <Controller
                                                            refs={registerFour("awards")}
                                                            name="awards"
                                                            control={controlFour}
                                                            render={({ field }) => (
                                                                <MuiChipsInput
                                                                    hideClearAll
                                                                    autoComplete="off"
                                                                    renderChip={(Component, key, props) => {
                                                                        return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                    }}
                                                                    addOnWhichKey={[",", "Enter"]}
                                                                    type="text"
                                                                    name="awards"
                                                                    placeholder={getValuesFour("awards")?.length === 0 || getValuesFour("awards") === undefined ? "Enter your awards name" : false}
                                                                    {...field}
                                                                />
                                                            )}
                                                        />
                                                        {errorsFour.awards && (
                                                            <p className="required">
                                                                {errorsFour.awards.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon22} alt="" />Phone Brand
                                                        </label>
                                                        <Controller
                                                            name="phone_brand"
                                                            refs={registerFour("phone_brand")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    isClearable={false}
                                                                    isMulti
                                                                    placeholder={"Enter Your Phone Brand"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.phoneBrands}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlFour}
                                                            defaultValue=""
                                                        />
                                                        {errorsFour.phone_brand && (
                                                            <p className="required">
                                                                {errorsFour.phone_brand.message}
                                                            </p>
                                                        )}
                                                    </div>

                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon23} alt="" />️Preferred
                                                            clothing style
                                                        </label>
                                                        <Controller
                                                            name="preferred_clothings"
                                                            refs={registerFour("preferred_clothings")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Enter your Preferred Clothings"}
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    options={dropDownValues?.clothingStyles}
                                                                    getOptionLabel={(option) => option.text}
                                                                    isMulti
                                                                    classNamePrefix="react-select"
                                                                    isClearable={false}
                                                                />
                                                            )}
                                                            control={controlFour}
                                                            defaultValue=""
                                                        />
                                                        {errorsFour.preferred_clothings && (
                                                            <p className="required">
                                                                {errorsFour.preferred_clothings.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-10">

                                                    {personalFormData?.phone_brand?.some(a => a.value === "other") && <div class="input-label-wrap others-label">
                                                        <Controller
                                                            refs={registerFour("other_phone_brand")}
                                                            name="other_phone_brand"
                                                            control={controlFour}
                                                            render={({ field }) => (
                                                                <MuiChipsInput
                                                                    autoComplete="off"
                                                                    hideClearAll
                                                                    renderChip={(Component, key, props) => {
                                                                        return <Component {...props} key={key} deleteIcon={<CloseIcon />} />
                                                                    }}
                                                                    onKeyPress={(e) => {
                                                                        if (e.key === ",") {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    addOnWhichKey={[",", "Enter"]}
                                                                    {...registerFour("other_phone_brand")}
                                                                    type="text"
                                                                    placeholder={getValuesFour("other_phone_brand")?.length === 0 || getValuesFour("other_phone_brand") === undefined ? "Other (Please Specify)" : false}
                                                                    {...field}
                                                                />
                                                            )}
                                                        />
                                                    </div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon24} alt="" />‍Mode of
                                                            shooting videos
                                                        </label>
                                                        <Controller
                                                            name="shooting_mode"
                                                            refs={registerFour("shooting_mode")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    menuPosition="fixed"
                                                                    {...field}
                                                                    isMulti
                                                                    isClearable={false}
                                                                    options={dropDownValues?.videoShootingTypes}
                                                                    getOptionLabel={(option) => option.text}
                                                                    placeholder={"Enter Your Shooting Mode"}
                                                                />
                                                            )}
                                                            control={controlFour}
                                                            defaultValue=""
                                                        />
                                                        {errorsFour.shooting_mode && (
                                                            <p className="required">
                                                                {errorsFour.shooting_mode.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-label-wrap">
                                                        <label htmlFor="">
                                                            <img src={formIcon25} alt="" />Food Preferences
                                                        </label>
                                                        <Controller
                                                            name="food_preferences"
                                                            refs={registerFour("food_preferences")}
                                                            render={({ field }) => (
                                                                <Select
                                                                    placeholder={"Enter your Food Preferences"}
                                                                    menuPosition="fixed"
                                                                    isClearable={false}
                                                                    {...field}
                                                                    options={dropDownValues?.foodPreferences}
                                                                    getOptionLabel={(option) => option.text}
                                                                />
                                                            )}
                                                            control={controlFour}
                                                            defaultValue=""
                                                        />
                                                        {errorsFour.food_preferences && (
                                                            <p className="required">
                                                                {errorsFour.food_preferences.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </form>
                            </>
                        </Tabs>
                        <div className="common-btn">
                            {validateDetail.detail_added ?
                                <div className="common-btn">
                                    {
                                        selectedTabs === 0 ? (
                                            <button
                                                form="formTwo"
                                                type="submit"
                                                className="btn-garys"
                                                onClick={() => setSubmitValueOne(true)}
                                            >
                                                Next
                                            </button>
                                        ) :
                                            selectedTabs === 1 ? (
                                                <button
                                                    form="formTwo"
                                                    type="submit"
                                                    className="btn-garys"
                                                    onClick={() => setSubmitValueTwo(true)}
                                                >
                                                    Next
                                                </button>
                                            ) : selectedTabs === 2 ? (
                                                <button
                                                    form="formThree"
                                                    type="submit"
                                                    className="btn-garys"
                                                    onClick={() => setSubmitValueThree(true)}
                                                >
                                                    Next
                                                </button>
                                            ) : null
                                    }
                                    <button
                                        form="formFour"
                                        type="submit"
                                        className="btn-green"
                                        onClick={() => setIsFormUpdate(true)}
                                    >
                                        Submit
                                    </button>
                                </div>
                                : selectedTabs === 0 ? (
                                    <button
                                        form="formOne"
                                        type="submit"
                                        className={channelName && Object.keys(platformData)?.length !== 0 ? "btn-green" : ""}
                                        onClick={onValidateUser}
                                    >
                                        Next
                                    </button>
                                ) : selectedTabs === 1 ? (
                                    <button
                                        form="formTwo"
                                        type="submit"
                                        className="btn-green"
                                        onClick={() => setSubmitValueTwo(true)}
                                    >
                                        Next
                                    </button>
                                ) : selectedTabs === 2 ? (
                                    <button
                                        form="formThree"
                                        type="submit"
                                        className="btn-green"
                                        onClick={() => setSubmitValueThree(true)}
                                    >
                                        Next
                                    </button>
                                ) : (
                                    <button
                                        form="formFour"
                                        type="submit"
                                        className="btn-green"
                                        onClick={() => setSubmitValueFour(true)}
                                    >
                                        Submit
                                    </button>
                                )}
                        </div>
                    </div>
                </div>

                <div
                    className="modal fade date-of-birth-wrap"
                    id="open-date-picker"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                // data-backdrop="static"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <p>Date</p>{" "}
                                <p>
                                    {agePicker ? moment(agePicker).format("DD MMM YYYY") : ""}
                                </p>
                            </div>
                            <div className="modal-body d-flex justify-content-center">
                                <div className="react-date-wrap">
                                    <Calendar
                                        weekDays={weekDays}
                                        shadow={false}
                                        value={agePicker === "" ? moment().subtract(18, "years")._d : agePicker}
                                        onChange={(date) => {
                                            setAgePicker(new Date(date));
                                            const dob = moment(new Date(date)).format("DD/MM/YYYY");
                                            setValueTwo("dob", dob, { shouldDirty: true });
                                        }}
                                        maxDate={moment().subtract(18, "years")._d}
                                    ></Calendar>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="common-btn">
                                    <button type="button" onClick={onDatePick}>
                                        Done
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal fade logout-popup-wrap save-store-popup"
                id="logout-personal-details"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-dialog-centered custom-popup "
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-body ">
                            <button
                                type="button"
                                data-dismiss="modal"
                                className="close save-close"
                            >
                                <span aria-hidden="true">
                                    <img src={Close_black} alt="" />
                                </span>
                            </button>
                            <div className="logout-card">
                                <p>Do you want to logout the screen?</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="common-btn">
                                <button data-dismiss="modal" onClick={() => {
                                    onSaveDetails();
                                    LogoutForm()
                                }}>Save and Logout</button>

                                <button data-dismiss="modal" onClick={() => LogoutForm()}>
                                    Logout without saving
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default IsLoadingHOC(PublicCreatorForm)
